import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { bindActionCreators } from 'redux';
import { domainActions, propertySkDomainKeys } from '../../../../store/domainStore';
import { isNullOrUndefined } from '../../../../store/storeFunctions';
import BbInput from '../../../styling/bbInput';
import SelectOption from '../../../searchSections/selectOption';

export const keys = {
    regionId: "regionId",
    districtId: "districtId",
    municipalityId: "municipalityId",
    cadastreUnitId: "cadastreUnitId"
};

export const excludedKeys = [keys.regionId, keys.districtId, keys.municipalityId];

class PropertySkSelectCadastreUnitForm extends React.Component {
    mounted = false;

    render() {
        const regions = this.getRegions();

        return (
            <>
            <div>
                <BbInput type="select-noformik" label={this.props.translate("PropertySk.Search.Region")} placeholder={{ type: "column" }} 
                    options={regions}
                    formatOptionLabel={SelectOption}
                    value={regions.find(f => f.value === this.props.regionId)}
                    onChange={(e) => this.regionChanged(e.value, this.props.setFieldValue)}
                />
            </div>
            <div>
                <BbInput type="select-noformik" label={this.props.translate("PropertySk.Search.District")} placeholder={{ type: "column" }}
                    disabled={isNullOrUndefined(this.props.regionId) || this.props.regionId === ""}
                    options={this.getDistricts(this.props.regionId)}
                    formatOptionLabel={SelectOption}
                    value={this.getCurrentDistrict(this.props.regionId, this.props.districtId)}
                    onChange={(e) => this.districtChanged(e.value, this.props.setFieldValue)}
                    isDisabled={isNullOrUndefined(this.props.regionId) || this.props.regionId === ""}
                />
               </div>
            <div>
                <BbInput type="select-noformik" label={this.props.translate("PropertySk.Search.Municipality")} placeholder={{ type: "column" }}
                    disabled={isNullOrUndefined(this.props.districtId) || this.props.districtId === ""}
                    options={this.getMunicipalities(this.props.districtId)}
                    formatOptionLabel={SelectOption}
                    value={this.getCurrentMunicipality(this.props.regionId, this.props.districtId, this.props.municipalityId)}
                    onChange={(e) => this.municipalityChanged(e.value, this.props.setFieldValue)}
                    isDisabled={isNullOrUndefined(this.props.districtId) || this.props.districtId === ""}
                />
            </div>
            <div>
                <BbInput type="select-noformik" label={this.props.translate("PropertySk.Search.CadastreUnit")} placeholder={{ type: "column" }}
                    disabled={isNullOrUndefined(this.props.municipalityId) || this.props.municipalityId === ""}
                    options={this.getCadastreUnits(this.props.municipalityId)}
                    formatOptionLabel={SelectOption}
                    value={this.getCurrentCadastreUnit(this.props.districtId, this.props.municipalityId, this.props.cadastreUnitId)}
                    onChange={(e) => this.props.setFieldValue(keys.cadastreUnitId, e.value)}
                    isDisabled={isNullOrUndefined(this.props.municipalityId) || this.props.municipalityId === ""}
                />
                </div>
            </>
        )
    }

    componentDidMount() {
        this.props.ensureDomainData(propertySkDomainKeys.districts);
        this.props.ensureDomainData(propertySkDomainKeys.municipalities);
        this.props.ensureDomainData(propertySkDomainKeys.cadastreUnits);
        this.mounted = true;
    }

    componentDidUpdate() {
        if (this.mounted && !this.hasDomainData(propertySkDomainKeys.districts))
            this.props.ensureDomainData(propertySkDomainKeys.districts);
        if (this.mounted && !this.hasDomainData(propertySkDomainKeys.municipalities))
            this.props.ensureDomainData(propertySkDomainKeys.municipalities);
        if (this.mounted && !this.hasDomainData(propertySkDomainKeys.cadastreUnits))
            this.props.ensureDomainData(propertySkDomainKeys.cadastreUnits);
    }

    hasDomainData = (key) => !(isNullOrUndefined(this.props.domain[key]) ||
        (isNullOrUndefined(this.props.domain[key].requestResult) || this.props.domain[key].isRequesting));

    getRegions = () => {
        const defaultChoice = { key: "", value: "", label: "" };
        if (!this.hasDomainData(propertySkDomainKeys.districts))
            return [defaultChoice];

        const regions = this.props.domain[propertySkDomainKeys.districts].requestResult.filter(f => f.parentId === null);
        return [defaultChoice, ...regions.map(r => ({ key: r.value, value: r.value, label: r.label }))];
    }

    getDistricts = (regionId) => {
        if (isNullOrUndefined(regionId) || regionId === "")
            return [];

        const defaultChoice = { key: "", value: "", label: "" };
        if (!this.hasDomainData(propertySkDomainKeys.districts))
            return [defaultChoice];

        const districts = this.props.domain[propertySkDomainKeys.districts].requestResult.filter(f => f.parentId === regionId);
        return [defaultChoice, ...districts.map(r => ({ key: r.value, value: r.value, label: r.label }))];
    }

    getMunicipalities = (districtId) => {
        if (isNullOrUndefined(districtId) || districtId === "")
            return [];

        const defaultChoice = { key: "", value: "", label: "" };
        if (!this.hasDomainData(propertySkDomainKeys.municipalities))
            return [defaultChoice];

        const municipalities = this.props.domain[propertySkDomainKeys.municipalities].requestResult.filter(f => f.parentId === districtId);
        return [defaultChoice, ...municipalities.map(r => ({ key: r.value, value: r.value, label: r.label }))];
    }

    getCadastreUnits = (municipalityId) => {
        if (isNullOrUndefined(municipalityId) || municipalityId === "")
            return [];

        const defaultChoice = { key: "", value: "", label: "" };
        if (!this.hasDomainData(propertySkDomainKeys.cadastreUnits))
            return [defaultChoice];

        const cadastreUnits = this.props.domain[propertySkDomainKeys.cadastreUnits].requestResult.filter(f => f.parentId === municipalityId);
        return [defaultChoice, ...cadastreUnits.map(r => ({ key: r.value, value: r.value, label: r.label }))];
    }

    regionChanged = (value, setFieldValue) => {
        setFieldValue(keys.regionId, value);
        setFieldValue(keys.districtId, "");
        setFieldValue(keys.municipalityId, "");
        setFieldValue(keys.cadastreUnitId, "");
    }

    districtChanged = (value, setFieldValue) => {
        setFieldValue(keys.districtId, value);
        setFieldValue(keys.municipalityId, "");
        setFieldValue(keys.cadastreUnitId, "");
    }

    municipalityChanged = (value, setFieldValue) => {
        setFieldValue(keys.municipalityId, value);
        setFieldValue(keys.cadastreUnitId, "");
    }

    getCurrentDistrict = (regionId, districtId) => isNullOrUndefined(regionId) || regionId === ""
        ? null : this.getDistricts(regionId).find(f => f.value === districtId);

    getCurrentMunicipality = (regionId, districtId, municipalityId) => isNullOrUndefined(districtId) || districtId === ""
        ? null : this.getMunicipalities(this.getDistricts(regionId).find(f => f.value === districtId).key).find(f => f.value === municipalityId);

    getCurrentCadastreUnit = (districtId, municipalityId, cadastreUnitId) => isNullOrUndefined(municipalityId) || municipalityId === ""
        ? null : this.getCadastreUnits(this.getMunicipalities(districtId).find(f => f.value === municipalityId).key).find(f => f.value === cadastreUnitId);
}

export default withRouter(withLocalize(connect(
    state => ({ ...state, domain: state.domain }),
    dispatch => bindActionCreators(domainActions, dispatch),
)(PropertySkSelectCadastreUnitForm)));